import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
const indicatorDotCss = "iypg2mc";
const indicatorDotStartCss = "ia6xvl4";
const indicatorDotEndCss = "i1vg4ayh";
const indicatorDotRealtimeCss = "i1cbmbdr";
const IndicatorDot = ({
  isEnd,
  isRealtime
}: {
  isEnd?: boolean;
  isRealtime?: boolean;
}) => <div className={classNames(indicatorDotCss, {
  [indicatorDotStartCss]: !isEnd,
  [indicatorDotEndCss]: isEnd,
  [indicatorDotRealtimeCss]: isRealtime
})} />;
const currentTimeIndicatorIsFirstCss = "cuiqg30";
const currentTimeIndicatorIsPhoneCss = "c1a15jk";
const currentTimeIndicatorIsRealtimeCss = "c2088ul";
const currentTimeIndicatorCss = "c1gtr3z3";
interface CurrentTimeIndicatorProps {
  isFirst?: boolean;
  isRealtime?: boolean;
  className?: string;
}

/**
 * Displays a visual indicator line marking the current time in a meeting list.
 * Shows a horizontal line with indicator dots to mark current position in the timeline.
 *
 * @param isFirst - Whether this is the first indicator in the list (adds top margin)
 * @param isRealtime - Whether to show the real-time indicator style (red color)
 * @param className - Optional CSS class name for additional styling
 */
export const CurrentTimeIndicator = ({
  isFirst,
  isRealtime,
  className,
  ...restProps
}: CurrentTimeIndicatorProps) => {
  const isPhone = useDeviceType('isPhone');
  return <div {...restProps} data-testid="current-time-indicator" className={classNames(currentTimeIndicatorCss, {
    [currentTimeIndicatorIsFirstCss]: isFirst,
    [currentTimeIndicatorIsPhoneCss]: isPhone,
    [currentTimeIndicatorIsRealtimeCss]: isRealtime
  }, className)}>
      <IndicatorDot isRealtime={isRealtime} />
      {!isRealtime && <IndicatorDot isEnd />}
    </div>;
};

require("./CurrentTimeIndicator.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./CurrentTimeIndicator.tsx");